import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
} from '@mui/material';

const STATUSES = [
  { value: 'IN_REVIEW', label: 'In Review' },
  { value: 'UNDER_INVESTIGATION', label: 'Under Investigation' },
  { value: 'FILED', label: 'Filed' },
  { value: 'CLOSED', label: 'Closed' },
];


export default function CaseDialog({
  open,
  mode,
  values,
  onChange,
  onClose,
  onSubmit,
}: {
  open: boolean;
  mode: 'create' | 'edit';
  values: any;
  onChange: (e: React.ChangeEvent<any>) => void;
  onClose: () => void;
  onSubmit: () => void;
}) {
  const safeValues = values ?? {};

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{mode === 'create' ? 'New Case' : 'Edit Case'}</DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
        <TextField
          label="Lead Defendant"
          name="lead_defendant"
          value={safeValues.lead_defendant ?? ''}
          onChange={onChange}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          label="Case Number"
          name="case_number"
          value={safeValues.case_number ?? ''}
          onChange={onChange}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          label="Court"
          name="court"
          value={safeValues.court ?? ''}
          onChange={onChange}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          label="Date Opened"
          name="date_opened"
          type="date"
          value={safeValues.date_opened ?? new Date().toISOString().split('T')[0]}
          onChange={onChange}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          label="Date Filed"
          name="date_filed"
          type="date"
          value={safeValues.date_filed ?? ''}
          onChange={onChange}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />

        <TextField
          label="Status"
          name="status"
          select
          value={safeValues.status ?? ''}
          onChange={onChange}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
        >
          {STATUSES.map((s) => (
            <MenuItem key={s.value} value={s.value}>
              {s.label}
            </MenuItem>
          ))}
        </TextField>

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSubmit}>
          {mode === 'create' ? 'Create' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
